import { hasSubProducts, getProductName } from "./marketingTrackingUtils";
import {
  shouldIncludeFlexibleSalesChannels,
  addFlexibleSalesChannels,
} from "./flexibleSalesChannelsUtils";

function buildBaseItemsDataTemplate({ products, variant, getQuantity }) {
  const baseTemplate = {
    item_id: variant.sku,
    productId: hasSubProducts(products) ? variant.productId : products.id,
    productCode: products.productCode,
    item_name: mapProductName(products, variant),
    item_brand: products.brandName,
    size: variant.size,
    itemType: "Product",
    item_variant: variant.colour,
    price: mapProductPriceGB(variant),
    priceLocalCurrency: mapProductPriceLocalCurrency(variant),
    google_business_vertical: "retail",
  };

  if (products.productType) {
    baseTemplate.item_category = products.productType.name;
  }

  if (getQuantity) {
    baseTemplate.quantity = 1;
  }

  if (shouldIncludeFlexibleSalesChannels(variant)) {
    baseTemplate.flexibleSalesChannels = addFlexibleSalesChannels(variant);
  }

  return baseTemplate;
}

export function itemsDataTemplate({ products, variant, getQuantity }) {
  const template = buildBaseItemsDataTemplate({
    products,
    variant,
    getQuantity,
  });

  if (variant.variantId) {
    template.variantId = variant.variantId.toString();
  }

  if (template.productId) {
    template.productId = template.productId.toString();
  }

  return template;
}

function mapProductName(product, variant) {
  return hasSubProducts(product)
    ? getProductName(product, variant)
    : product.name;
}

const mapProductPriceGB = (variant) =>
  variant.priceObj?.xrp.value ?? variant.price?.xrp.value;

const mapProductPriceLocalCurrency = (variant) =>
  variant.priceObj?.current.value ?? variant.price?.current.value;
